import Axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import ProductCard from "../../../components/ProductCard/ProductCard";
import Spinner from "../../../components/Spinner/Spinner";
import FlexContainer from "../../../components/UI/FlexContainer/FlexContainer";
import ToggleSwtich from "../../../components/UI/ToggleSwitch/ToggleSwtich";
import withErrorHandler from "../../../hoc/withErrorHandler/withErrorHandler";
import * as actions from "../../../store/actions/index";
import Sections from "./Section/Sections";

class AddSectionForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "",
      url: "",
      workoutPlan: {
        title: "",
        // categoryName: "",
        desc: "",
        // workouts: [],
      },
      selectedSectionId: null,
      productIds: [],
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleWorkoutChange = this.handleWorkoutChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleAddWorkout = this.handleAddWorkout.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }

  componentDidMount() {
    this.props.fetchWorkoutPlans();
    // this.props.onFetchCategory();
  }

  handleChange(e) {
    const { name, value } = e.target;
    let workoutPlan = { ...this.state.workoutPlan };
    workoutPlan[name] = value;
    this.setState({ workoutPlan: workoutPlan });
  }

  handleWorkoutChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  handleSubmit(e) {
    e.preventDefault();
    // console.log("Workout Plan",this.state.workoutPlan);
    let homeSection = this.state.workoutPlan;
    homeSection.visible = true;
    this.props.addWorkoutPlan(homeSection, this.props.workouts);
  }

  handleAddWorkout(e) {
    e.preventDefault();
    let workout = {
      title: this.state.title,
      url: this.state.url,
    };
    let workoutArray = this.state.workoutPlan.workouts;
    workoutArray.push(workout);
    this.setState({ workoutArray: workoutArray });
    console.log(workoutArray);
  }

  handleRemove(e, workout) {
    e.preventDefault();
    console.log(workout);
  }
  handleSectionClicked = (sectionId, productIds) => {
    if (productIds) {
      this.setState({ selectedSectionId: sectionId, productIds: productIds });
      this.props.fetchSectionProducts(sectionId, productIds);
    }
  };

  renderSectionProducts = () => {
    // console.log("render Section Products");
    let sectionId = this.state.selectedSectionId;
    let products = [];
    if (sectionId) {
      let homeSectionProducts = this.props.homeSectionProducts;
      if (homeSectionProducts[sectionId]) {
        homeSectionProducts[sectionId].map((product) => {
          products.push(
            <span
              className="border-secondary p-2 rounded-sm mr-4"
              style={{ border: "1px solid", width: "240px" }}
            >
              <span className="d-flex w-100 justify-content-between">
                <button
                  className="btn btn-sm btn-danger"
                  onClick={() =>
                    this.props.removeProductFromSection(sectionId, product.id)
                  }
                >
                  Remove
                </button>
              </span>
              <ProductCard product={product} />
            </span>
          );
        });
      }
    }
    return products;
  };

  render() {
    // console.log(this.props.homeSectionProducts);
    let plans = this.props.homeSections;
    // console.log("Rendering");
    return (
      <div>
        <h3 className="text-center">Home Section Management</h3>
        <hr />
        <form onSubmit={this.handleSubmit}>
          <div className="row mx-4">
            <div class="form-group col-md-3">
              <label for="workoutTitle">Title</label>
              <input
                name="title"
                type="text"
                id="workoutTitle"
                className="form-control"
                onChange={this.handleChange}
                placeholder="Enter Section Title"
                value={this.state.workoutPlan.title}
                required
              />
            </div>

            <div className="form-group col-md-4">
              <label for="Description">Description</label>
              <textarea
                name="desc"
                type="text"
                id="Description"
                className="form-control"
                placeholder="Description"
                onChange={this.handleChange}
                value={this.state.workoutPlan.desc}
                rows="3"
                required
              />
            </div>
            <div className="form-group col-md-2">
              <label for="sequence">Sequence</label>
              <input
                name="sequence"
                className="form-control"
                id="sequence"
                type="number"
                min={1}
                placeholder="Sequence"
                onChange={this.handleChange}
                required
              />
            </div>
            <div className="form-group col-md-2">
              <label for="sequence">Sequence</label>
              <input
                name="seeAllUrl"
                className="form-control"
                id="seeAllUrl"
                type="text"
                placeholder="See All Link"
                onChange={this.handleChange}
              />
            </div>
            <button
              type="submit"
              className="btn btn-sm btn-success d-inline"
              style={{ marginTop: "5rem", marginBottom: "2rem" }}
              disabled={this.props.addPlanLoading}
            >
              {this.props.addPlanLoading ? "Saving" : "Save"}
            </button>
          </div>
        </form>
        <hr />
        {!this.props.loading ? (
          <div className="d-flex container flex-nowrap">
            <div
              className="nav flex-column nav-pills"
              id="v-pills-tab"
              role="tablist"
              aria-orientation="vertical"
            >
              {plans.map((plan, index) => (
                <>
                  <a
                    className={`nav-link `}
                    id="v-pills-home-tab"
                    data-toggle="pill"
                    href="#v-pills-home"
                    role="tab"
                    aria-controls="v-pills-home"
                    aria-selected="true"
                    style={{
                      color: "black",
                      border: "1px solid grey",
                      borderBottom: "none",
                    }}
                    onClick={() =>
                      this.handleSectionClicked(plan.id, plan.products)
                    }
                  >
                    {plan.title}
                  </a>

                  <div
                    style={{
                      border: "1px solid grey",
                      marginBottom: "1rem",
                      position: "relative",
                    }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        right: "7px",
                        top: "-32px",
                      }}
                    >
                      <ToggleSwtich
                        checked={plan.visible}
                        clicked={(status) =>
                          this.props.setVisiblityOfSection(plan.id, status)
                        }
                      />
                    </div>

                    <Sections plan={plan} index={index} />
                  </div>
                </>
              ))}
            </div>

            <div className="tab-content" id="v-pills-tabContent">
              <div
                className="tab-pane fade show "
                id="v-pills-home"
                role="tabpanel"
                aria-labelledby="v-pills-home-tab"
              >
                <div className="container">
                  {this.props.sectionProductsLoading ? (
                    <Spinner />
                  ) : (
                    <FlexContainer>
                      {this.renderSectionProducts()}
                    </FlexContainer>
                  )}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <Spinner />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    homeSections: state.homeProducts.homeSections,
    homeSectionProducts: state.homeProducts.homeSectionProducts,
    loading: state.homeProducts.sectionLoading,
    sectionProductsLoading: state.homeProducts.sectionProductsLoading,
    addPlanLoading: state.homeProducts.addSectionLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchWorkoutPlans: () => dispatch(actions.fetchHomeSections()),
    // onFetchCategory: () => dispatch(actions.fetchCategoryAdmin()),
    addWorkoutPlan: (plan, workouts_plans) =>
      dispatch(actions.addHomeSection(plan, workouts_plans)),
    fetchSectionProducts: (sectionId, productIdsArray) =>
      dispatch(
        actions.fetchSectionProductsFromArrayOfIds(sectionId, productIdsArray)
      ),
    removeProductFromSection: (sectionId, productId) =>
      dispatch(actions.removeProductFromSection(sectionId, productId)),
    setVisiblityOfSection: (sectionId, status) =>
      dispatch(actions.setVisiblityOfSection(sectionId, status)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorHandler(AddSectionForm, Axios));
